export class Permission {
  create: boolean;
  mode: boolean;
  show: boolean;
  update: boolean;
  delete: boolean;

  constructor() {
    this.create = false;
    this.mode = false;
    this.show = false;
    this.update = false;
    this.delete = false;
  }
}
